<template>
  <td>
    <VLotFavorites class="lot-favorites--table" :is-favorites="row.is_follow" :lot-id="row.id" />
  </td>
</template>

<script setup>
import VLotFavorites from '@/components/list/LotList/Lot/Part/VLotFavorites'
import { defineProps } from 'vue'

defineProps({
  row: {
    type: Object,
    required: true,
  },
})
</script>
